



















































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateIntegralrule from "./create-integralrule.vue";
 
import EditIntegralrule from "./edit-integralrule.vue";

 

class PageIntegralruleRequest extends PageRequest {
  Keyword: string;
  //isrent: number; //nullable
  stime: Date;
  etime: Date;
}

@Component({
  components: { EditIntegralrule,CreateIntegralrule },
})
export default class Integralrule extends AbpBase {
  edit() {
    this.editModalShow = true;
  }
  //filters
  pagerequest: PageIntegralruleRequest = new PageIntegralruleRequest();
  creationTime: Date[] = [];
  editModalShow: boolean = false;
  createModalShow: boolean = false;
   

  get list() {
    return this.$store.state.integralrule.list;
  }
  get loading() {
     
    return this.$store.state.integralrule.loading;
  }
  create() {
     this. createModalShow=true;
  }

  pageChange(page: number) {
    this.$store.commit("integralrule/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("integralrule/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters

    if (this.creationTime.length > 0) {
      this.pagerequest.stime = this.creationTime[0];
    }
    if (this.creationTime.length > 1) {
      this.pagerequest.etime = this.creationTime[1];
    }

    await this.$store.dispatch({
      type: "integralrule/getAll",
      data: this.pagerequest,
    });
  }
  async getAreaAll() {
    await this.$store.dispatch({
      type: "integralrule/getQAreaAllData",
    });
  }
  async GetRubbishType1() {
    await this.$store.dispatch({
      type: "integralrule/GetRubbishType1",
    });
  }
  async GetRubbishType2() {
    await this.$store.dispatch({
      type: "integralrule/GetRubbishType2",
    });
  }
  get pageSize() {
    return this.$store.state.integralrule.pageSize;
  }
  get totalCount() {
    return this.$store.state.integralrule.totalCount;
  }
  get currentPage() {
    return this.$store.state.integralrule.currentPage;
  }
   rbtyTxt(val:number){
    debugger
        let t="";
       var dt= this.$store.state.integralrule.rbty2.data;
         dt.forEach(item=>{
        if(item.id==val){
           t=item.fname;
           if(item.fid==2){
                   t=item.fname+"("+item.name+")";
             }
        }
      })
  
    return t;
  }

  columns = [
     

      {
      title: this.L("VilName"),
      render: (h: any, params: any) => {
        return h("span", params.row.vArea.vilname);
      },
    },

    {
      title: this.L("分值"),
      key: "score",
    },
    {
      title: this.L("单日最大次数"),
      key: "maxNum",
    },
     {
      title: this.L("垃圾种类"),
      render: (h: any, params: any) => {
          let recyTypetxt=this.rbtyTxt(params.row.recyClassId);
         
         
        return h("span", recyTypetxt);
      },
    },
    

    

     {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                
                  this.$store.commit("integralrule/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteUserConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "integralrule/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ),
        ]);
      },
    },
  ];
  async created() {
    this.getpage();
    this.getAreaAll();
    this.GetRubbishType1();
    this.GetRubbishType2();
  }
}
